<template>
  <div>
    <NavBar></NavBar>
    <p>Pagina de cotización</p>
  </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
export default {
  name: "HomeView",
  components: {
    NavBar,
  },
};
</script>
<style scoped>
</style>